import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { FILE_INCORRECT } from "@/features/company/constants/excel";
import { TOption } from "@/types/common";

const TEMPLATE_END_ROW = 201;

const columnWidths: Record<number, number> = {
  1: 20, // A: ステータス
  2: 26, // B: タグ（優先ステータス）
  3: 18, // C: 募集開始日
  4: 18, // D: 募集終了日
  5: 22, // E: 紹介事業所名
  6: 18, // F: 求人担当者
  7: 22, // G: ステータスメモ
  8: 24, // H: 企業名
  9: 20, // I: 求人管理番号
  10: 30, // J: 求人名
  11: 20, // K: 分野
  12: 20, // L: 業務区分
  13: 28, // M: 取扱業務等の区分
  14: 16, // N: 募集人数
  15: 22, // O: 紹介料（売上）
  16: 22, // P: 紹介料（仕入）
  17: 22, // Q: 求人獲得ルート
  18: 16, // R: 顧客区分
  19: 24, // S: 求人担当者コメント
  20: 30, // T: 業務内容
  21: 18, // U: 雇用形態
  22: 16, // V: 給与形態
  23: 16, // W: 総支給額1
  24: 22, // X: 総支給額の内訳1
  25: 16, // Y: 控除金額1
  26: 22, // Z: 控除内容の詳細1
  27: 20, // AA: 目安手取り金額1
  28: 24, // AB: 手取り金額計算背景1
  29: 16, // AC: 総支給額2
  30: 22, // AD: 総支給額の内訳2
  31: 16, // AE: 控除金額2
  32: 22, // AF: 控除内容の詳細2
  33: 20, // AG: 目安手取り金額2
  34: 24, // AH: 手取り金額計算背景2
  35: 16, // AI: 総支給額3
  36: 22, // AJ: 総支給額の内訳3
  37: 16, // AK: 控除金額3
  38: 22, // AL: 控除内容の詳細3
  39: 20, // AM: 目安手取り金額3
  40: 24, // AN: 手取り金額計算背景3
  41: 24, // AO: その他手当の内容
  42: 20, // AP: 残業について
  43: 14, // AQ: 賞与
  44: 22, // AR: 賞与時期・金額
  45: 14, // AS: 昇給
  46: 18, // AT: 昇給時期
  47: 34, // AU: 雇用条件に関する補足事項
  48: 20, // AV: 勤務場所
  49: 24, // AW: 勤務地（詳細）
  50: 14, // AX: 始業1
  51: 14, // AY: 終業1
  52: 16, // AZ: 休憩時間
  53: 22, // BA: 休日（定例日）
  54: 22, // BB: 休日（非定例日）
  55: 26, // BC: 年間合計休日日数
  56: 22, // BD: 必要な日本語レベル
  57: 34, // BE: 必要な日本語レベル（その他）
  58: 28, // BF: 必要な技能・経験
  59: 24, // BG: その他応募要件
  60: 24, // BH: 年齢制限（上限）
  61: 16, // BI: 国籍
  62: 20, // BJ: 募集地
  63: 20, // BK: 採用希望時期
  64: 14, // BL: 性別
  65: 20, // BM: 在留資格
  66: 24, // BN: 特定技能試験合格
  67: 28, // BO: 求人票URL
  68: 24, // BP: 選考フロー
  69: 24, // BQ: 社宅・住居情報
  70: 24, // BR: 特定技能2号支援
  71: 42, // BS: その他福利厚生や宗教面配慮の有無等
  72: 36, // BT: 社会保険・雇用保険の加入状況
  73: 24, // BU: 本人負担費用
  74: 40, // BV: 求人企業の特徴（選考ポイント）
  75: 20, // BW: 在籍外国人
  76: 28, // BX: 受け入れ体制・サポート
};

export const headers: string[] = [
  "ステータス",
  "タグ（優先ステータス）",
  "募集開始日",
  "募集終了日",
  "紹介事業所名",
  "求人担当者",
  "ステータスメモ",
  "企業名",
  "求人管理番号",
  "求人名",
  "分野",
  "業務区分",
  "取扱業務等の区分",
  "募集人数",
  "紹介料（売上）",
  "紹介料（仕入）",
  "求人獲得ルート",
  "顧客区分",
  "求人担当者コメント",
  "業務内容",
  "雇用形態",
  "給与形態",
  "総支給額1",
  "総支給額の内訳1",
  "控除金額1",
  "控除内容の詳細1",
  "目安手取り金額1",
  "手取り金額計算背景1",
  "総支給額2",
  "総支給額の内訳2",
  "控除金額2",
  "控除内容の詳細2",
  "目安手取り金額2",
  "手取り金額計算背景2",
  "総支給額3",
  "総支給額の内訳3",
  "控除金額3",
  "控除内容の詳細3",
  "目安手取り金額3",
  "手取り金額計算背景3",
  "その他手当の内容",
  "残業について",
  "賞与",
  "賞与時期・金額",
  "昇給",
  "昇給時期",
  "雇用条件に関する補足事項",
  "勤務場所",
  "勤務地（詳細）",
  "始業1",
  "終業1",
  "休憩時間",
  "休日（定例日）",
  "休日（非定例日）",
  "年間合計休日日数",
  "必要な日本語レベル",
  "必要な日本語レベル（その他）",
  "必要な技能・経験",
  "その他応募要件",
  "年齢制限（上限）",
  "国籍",
  "募集地",
  "採用希望時期",
  "性別",
  "在留資格",
  "特定技能試験合格",
  "求人票URL",
  "選考フロー",
  "社宅・住居情報",
  "特定技能2号支援",
  "その他福利厚生や宗教面配慮の有無等",
  "社会保険・雇用保険の加入状況",
  "本人負担費用",
  "求人企業の特徴（選考ポイント）",
  "在籍外国人",
  "受け入れ体制・サポート",
];

export const headerToKey: Record<string, string> = {
  ステータス: "status",
  "タグ（優先ステータス）": "tag",
  募集開始日: "recruitmentStartDate",
  募集終了日: "recruitmentEndDate",
  紹介事業所名: "referralOfficeName",
  求人担当者: "recruiterName",
  ステータスメモ: "statusMemo",
  企業名: "companyName",
  求人管理番号: "managementNumber",
  求人名: "jobName",
  分野: "companySpecificIndustry",
  業務区分: "businessCategory",
  取扱業務等の区分: "businessHandlingCategory",
  募集人数: "recruitmentNumber",
  "紹介料（売上）": "referralFeeSales",
  "紹介料（仕入）": "referralFeePurchase",
  求人獲得ルート: "acquisitionRoute",
  顧客区分: "customerType",
  求人担当者コメント: "recruiterComment",
  業務内容: "jobDescription",
  雇用形態: "employmentType",
  給与形態: "salaryType",
  総支給額1: "grossSalary1",
  総支給額の内訳1: "grossSalaryBreakdown1",
  控除金額1: "deduction1",
  控除内容の詳細1: "deductionDetail1",
  目安手取り金額1: "netSalary1",
  手取り金額計算背景1: "netSalaryBackground1",
  総支給額2: "grossSalary2",
  総支給額の内訳2: "grossSalaryBreakdown2",
  控除金額2: "deduction2",
  控除内容の詳細2: "deductionDetail2",
  目安手取り金額2: "netSalary2",
  手取り金額計算背景2: "netSalaryBackground2",
  総支給額3: "grossSalary3",
  総支給額の内訳3: "grossSalaryBreakdown3",
  控除金額3: "deduction3",
  控除内容の詳細3: "deductionDetail3",
  目安手取り金額3: "netSalary3",
  手取り金額計算背景3: "netSalaryBackground3",
  その他手当の内容: "otherAllowances",
  残業について: "overtime",
  賞与: "bonus",
  "賞与時期・金額": "bonusDetail",
  昇給: "salaryRaise",
  昇給時期: "salaryRaiseDetail",
  雇用条件に関する補足事項: "employmentConditionNote",
  勤務場所: "workplace",
  "勤務地（詳細）": "workplaceDetail",
  始業1: "workStartTime1",
  終業1: "workEndTime1",
  休憩時間: "breakTime",
  "休日（定例日）": "regularHoliday",
  "休日（非定例日）": "irregularHoliday",
  年間合計休日日数: "annualHolidayDays",
  必要な日本語レベル: "japaneseLevelType",
  "必要な日本語レベル（その他）": "japaneseLevelOther",
  "必要な技能・経験": "requiredSkills",
  その他応募要件: "otherRequirements",
  "年齢制限（上限）": "ageLimit",
  国籍: "nationality",
  募集地: "recruitmentLocationType",
  採用希望時期: "desiredHiringDate",
  性別: "gender",
  在留資格: "residenceStatus",
  特定技能試験合格: "specificSkillExam",
  求人票URL: "jobPostingUrl",
  選考フロー: "selectionFlow",
  "社宅・住居情報": "housingInfo",
  特定技能2号支援: "specificSkill2Support",
  その他福利厚生や宗教面配慮の有無等: "otherBenefits",
  "社会保険・雇用保険の加入状況": "insuranceStatus",
  本人負担費用: "personalExpenses",
  "求人企業の特徴（選考ポイント）": "companyFeatures",
  在籍外国人: "foreignWorkers",
  "受け入れ体制・サポート": "supportSystem",
};

type TDownloadSampleOptions = {
  // Master data (単一選択 from API)
  companySpecificIndustry?: TOption[];
  businessClassification?: TOption[];
  referralOffice?: TOption[];
  recruiter?: TOption[];
  // Enum data (単一選択)
  jobStatus?: TOption[];
  jobTag?: TOption[];
  employmentType?: TOption[];
  salaryType?: TOption[];
  yesNoPending?: TOption[];
  japaneseLevelType?: TOption[];
  recruitmentLocationType?: TOption[];
};

// Build comma-separated formula string from TOption[], fallback to hardcoded
const buildEnumFormula = (options: TOption[] | undefined, fallback: string): string => {
  if (options && options.length > 0) {
    return `"${options.map((o) => o.label).join(",")}"`;
  }
  return `"${fallback}"`;
};

export const downloadSample = async (options: TDownloadSampleOptions = {}) => {
  const { companySpecificIndustry = [], businessClassification = [], referralOffice = [], recruiter = [] } = options;

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("求人情報");

  // Master sheet for dynamic data (A=companySpecificIndustry, B=businessClassification, C=referralOffice, D=recruiter)
  const masterSheet = workbook.addWorksheet("Master");
  const industryCount = companySpecificIndustry.length;
  const businessClassificationCount = businessClassification.length;
  const referralOfficeCount = referralOffice.length;
  const recruiterCount = recruiter.length;

  companySpecificIndustry.forEach((item, idx) => {
    masterSheet.getCell("A" + (idx + 1)).value = item.label;
  });
  businessClassification.forEach((item, idx) => {
    masterSheet.getCell("B" + (idx + 1)).value = item.label;
  });
  referralOffice.forEach((item, idx) => {
    masterSheet.getCell("C" + (idx + 1)).value = item.label;
  });
  recruiter.forEach((item, idx) => {
    masterSheet.getCell("D" + (idx + 1)).value = item.label;
  });

  masterSheet.state = "veryHidden";

  const headerRow = sheet.addRow(headers);

  const sampleRow = [
    "募集中", // ステータス
    "急募", // タグ
    "2025/04/01", // 募集開始日
    "2025/09/30", // 募集終了日
    referralOffice.length > 0 ? referralOffice[0].label : "東京支店", // 紹介事業所名
    recruiter.length > 0 ? recruiter[0].label : "田中太郎", // 求人担当者
    "", // ステータスメモ
    "株式会社サンプル", // 企業名
    "JOB-2025-001", // 求人管理番号
    "製造スタッフ", // 求人名
    "工業製品製造業", // 分野
    "機械金属加工", // 業務区分
    "製品製造・加工処理工（金属製品）", // 取扱業務等の区分
    "3", // 募集人数
    "300000", // 紹介料（売上）
    "200000", // 紹介料（仕入）
    "紹介会社", // 求人獲得ルート
    "新規｜既存", // 顧客区分（複数選択：｜区切り）
    "即戦力歓迎", // 求人担当者コメント
    "金属部品の加工・組立業務", // 業務内容
    "直接雇用", // 雇用形態
    "月給", // 給与形態
    "220000", // 総支給額1
    "基本給180000+手当40000", // 総支給額の内訳1
    "30000", // 控除金額1
    "社会保険・税金", // 控除内容の詳細1
    "190000", // 目安手取り金額1
    "月給220000から控除30000を差し引き", // 手取り金額計算背景1
    "",
    "",
    "",
    "",
    "",
    "", // 総支給額2〜手取り金額計算背景2
    "",
    "",
    "",
    "",
    "",
    "", // 総支給額3〜手取り金額計算背景3
    "交通費全額支給", // その他手当の内容
    "月20時間程度", // 残業について
    "有", // 賞与
    "年2回・各1ヶ月分", // 賞与時期・金額
    "有", // 昇給
    "年1回・4月", // 昇給時期
    "", // 雇用条件に関する補足事項
    "愛知県豊田市", // 勤務場所
    "愛知県豊田市○○町1-1", // 勤務地（詳細）
    "08:00", // 始業1
    "17:00", // 終業1
    "60", // 休憩時間
    "土日", // 休日（定例日）
    "祝日", // 休日（非定例日）
    "120", // 年間合計休日日数
    "N3", // 必要な日本語レベル
    "", // 必要な日本語レベル（その他）
    "金属加工経験1年以上", // 必要な技能・経験
    "", // その他応募要件
    "45", // 年齢制限（上限）
    "国籍問わず", // 国籍
    "国内", // 募集地
    "2025/07/01", // 採用希望時期
    "性別不問", // 性別
    "技能実習", // 在留資格
    "", // 特定技能試験合格
    "https://example.com/job/001", // 求人票URL
    "書類選考→面接1回", // 選考フロー
    "社宅あり（月2万円）", // 社宅・住居情報
    "", // 特定技能2号支援
    "宗教配慮食事あり", // その他福利厚生や宗教面配慮の有無等
    "健康保険・厚生年金・雇用保険・労災保険", // 社会保険・雇用保険の加入状況
    "国内移動費本人負担", // 本人負担費用
    "外国人受け入れ実績多数・日本語研修あり", // 求人企業の特徴
    "5名", // 在籍外国人
    "会社寮完備", // 受け入れ体制・サポート
  ];

  sheet.addRow(sampleRow);

  headerRow.eachCell((cell, colNumber) => {
    cell.font = { name: "Calibri", bold: true, size: 14, color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF4472C4" },
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    const column = sheet.getColumn(colNumber);
    column.width = columnWidths[colNumber] || 15;
  });

  sheet.views = [{ state: "frozen", ySplit: 1 }];

  // Enum formulas — use API data if available, fallback to hardcoded
  const statusFormula = buildEnumFormula(options.jobStatus, "下書き,募集予定,募集中,募集停止,募集終了");
  const tagFormula = buildEnumFormula(options.jobTag, "急募,常時募集");
  const employmentTypeFormula = buildEnumFormula(options.employmentType, "直接雇用,派遣雇用");
  const salaryTypeFormula = buildEnumFormula(options.salaryType, "時給,日給,月給");
  const yesNoPendingFormula = buildEnumFormula(options.yesNoPending, "有,無,確認中");
  const japaneseLevelFormula = buildEnumFormula(options.japaneseLevelType, "N1,N2,N3,N4");
  const recruitmentLocationFormula = buildEnumFormula(options.recruitmentLocationType, "国内,国外,国内外問わず");

  for (let i = 2; i <= TEMPLATE_END_ROW; i++) {
    // 単一選択 (single select) — enum dropdowns
    sheet.getCell(`A${i}`).dataValidation = { type: "list", formulae: [statusFormula], showInputMessage: true };
    sheet.getCell(`B${i}`).dataValidation = { type: "list", formulae: [tagFormula], showInputMessage: true };
    sheet.getCell(`U${i}`).dataValidation = { type: "list", formulae: [employmentTypeFormula], showInputMessage: true };
    sheet.getCell(`V${i}`).dataValidation = { type: "list", formulae: [salaryTypeFormula], showInputMessage: true };
    sheet.getCell(`AQ${i}`).dataValidation = { type: "list", formulae: [yesNoPendingFormula], showInputMessage: true };
    sheet.getCell(`AS${i}`).dataValidation = { type: "list", formulae: [yesNoPendingFormula], showInputMessage: true };
    sheet.getCell(`BD${i}`).dataValidation = { type: "list", formulae: [japaneseLevelFormula], showInputMessage: true };
    sheet.getCell(`BJ${i}`).dataValidation = { type: "list", formulae: [recruitmentLocationFormula], showInputMessage: true };
    sheet.getCell(`BL${i}`).dataValidation = { type: "list", formulae: ['"男性,女性,性別不問"'], showInputMessage: true };

    // 単一選択 — master data (from hidden Master sheet)
    if (referralOfficeCount > 0) {
      sheet.getCell(`E${i}`).dataValidation = {
        type: "list",
        formulae: [`=Master!$C$1:$C$${referralOfficeCount}`],
        showInputMessage: true,
      };
    }

    if (recruiterCount > 0) {
      sheet.getCell(`F${i}`).dataValidation = {
        type: "list",
        formulae: [`=Master!$D$1:$D$${recruiterCount}`],
        showInputMessage: true,
      };
    }

    if (industryCount > 0) {
      sheet.getCell(`K${i}`).dataValidation = {
        type: "list",
        formulae: [`=Master!$A$1:$A$${industryCount}`],
        showInputMessage: true,
      };
    }

    if (businessClassificationCount > 0) {
      sheet.getCell(`M${i}`).dataValidation = {
        type: "list",
        formulae: [`=Master!$B$1:$B$${businessClassificationCount}`],
        showInputMessage: true,
      };
    }

    // 複数選択 fields (顧客区分, 業務区分, 国籍, 在留資格, etc.) — no dropdown
    // User types values separated by ｜ (e.g. "新規｜既存")

    // Date format columns
    sheet.getCell(`C${i}`).numFmt = "yyyy/mm/dd";
    sheet.getCell(`D${i}`).numFmt = "yyyy/mm/dd";
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/octet-stream" });
  saveAs(blob, "求人情報_サンプル.xlsx");
};

export const validateFileFormat = (rowHeader: string[], optionalHeaders?: string[]) => {
  const header = rowHeader
    .filter((h) => h !== "")
    .map((h) =>
      String(h)
        .replace(/^\uFEFF/, "")
        .trim(),
    );

  const optionalSet = new Set(optionalHeaders ?? []);
  const expectedHeaders = headers.filter((h) => !optionalSet.has(h));

  if (header.length !== expectedHeaders.length) {
    throw new Error(FILE_INCORRECT);
  }

  for (let i = 0; i < expectedHeaders.length; i++) {
    if (header[i] !== expectedHeaders[i]) {
      throw new Error(FILE_INCORRECT);
    }
  }

  return { isValid: true };
};
